import Table from './Table';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFooter from './TableFooter';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

export { Table, TableHeader, TableBody, TableFooter, TableRow, TableCell };

export default Table;
